import React from 'react';
import Routers from 'routers';

function App() {
  return (
    <div className="App">
      <Routers />
    </div>
  );
}

export default App;
